import type { ReactElement } from "react";
import { useState } from "react";
import type { ResourceFaq } from "../types";
import { ArrowIcon } from "./ArrowIcon";

interface FaqAccordionProps {
  items: ResourceFaq[];
}

export const FaqAccordion = ({ items }: FaqAccordionProps): ReactElement => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="resources-faq__list">
      {items.map((item, index) => {
        const isOpen = openIndex === index;

        return (
          <article className={isOpen ? "resources-faq__item is-open" : "resources-faq__item"} key={item.question}>
            <h3>
              <button aria-expanded={isOpen} onClick={() => setOpenIndex(isOpen ? null : index)} type="button">
                {item.question}
                <span aria-hidden="true">{isOpen ? "−" : "+"}</span>
              </button>
            </h3>
            {isOpen && (
              <div className="resources-faq__answer">
                <p>{item.answer}</p>
                <a href={item.href}>
                  Explore the full guide <ArrowIcon size={16} />
                </a>
              </div>
            )}
          </article>
        );
      })}
    </div>
  );
};
